export default __webpack_public_path__ + "static/questionnaire-7a166559aacd86a563dcdcae7f56fbf8.png";